var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('bsi-navigation'),_c('b-container',{staticClass:"mt-4"},[_c('router-view')],1),_c('bsi-footer'),_c('vue-progress-bar'),(_vm.branch == 'swim')?_c('cookie-consent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }